import styled, { css } from 'styled-components';
import { MEDIA_QUERY } from '@optimus-web/breakpoints';
import { getSpacingToken, getToken, ZIndex } from '@optimus-web/common';
import { StyledTransitionGroup } from '@optimus-web/helpers';
import { APPBAR_DESKTOP_HEIGHT, APPBAR_MOBILE_HEIGHT } from '../Appbar';
import { Stack } from '../Stack';
import { getAlertItemIconBackgroundColor, getAlertItemIconColor } from './getAlertStyles';
import { AlertContainerPosition, AlertTransitionGroupProps, AlertVariant } from './types';

export const AlertTransitionGroup = styled(StyledTransitionGroup).withConfig<AlertTransitionGroupProps>({
    shouldForwardProp: (prop, defaultValidatorFn) =>
        !['desktopOffset', 'mobileOffset'].includes(prop) && defaultValidatorFn(prop),
})`
    top: ${(props) =>
        (typeof props.desktopOffset === 'number' ? props.desktopOffset : APPBAR_DESKTOP_HEIGHT) +
        getSpacingToken('200')({ theme: props.theme })}px;
    right: ${getSpacingToken('200')}px;
    z-index: ${ZIndex.Highest};
    position: fixed;

    ${(props) =>
        props.position === AlertContainerPosition.Center &&
        css`
            ${MEDIA_QUERY.tabletUp} {
                right: auto;
                left: 50%;
                transform: translateX(-50%);
            }
        `}

    > *:not(:first-child) {
        margin-top: ${getSpacingToken('100')}px;

        ${MEDIA_QUERY.desktopUp} {
            margin-top: ${getSpacingToken('200')}px;
        }
    }

    ${MEDIA_QUERY.largePhoneMax} {
        width: auto;
        top: ${(props) =>
            (typeof props.mobileOffset === 'number' ? props.mobileOffset : APPBAR_MOBILE_HEIGHT) +
            getSpacingToken('100')({ theme: props.theme })}px;
        right: ${getSpacingToken('200')}px;
        left: ${getSpacingToken('200')}px;
    }
`;

export const AlertItemWrapper = styled.div`
    background: ${getToken('backgroundStaticFloating')};
    box-shadow: ${getToken('shadow300')};
    border-radius: ${getToken('borderRadius100')}px;
    display: flex;
    gap: ${getSpacingToken('100')}px;
    width: 360px;
    max-width: 100%;
    min-height: max-content;

    ${MEDIA_QUERY.tabletUp} {
        max-width: 360px;
    }
`;

export const AlertItemIcon = styled(Stack)<{ variant: AlertVariant }>`
    width: ${getToken('sizing500')}px;
    background: ${({ variant }) => getAlertItemIconBackgroundColor(variant)};
    color: ${({ variant }) => getAlertItemIconColor(variant)};
    border-radius: ${getToken('borderRadius100')}px 0 0 ${getToken('borderRadius100')}px;
    flex-shrink: 0;
    padding: ${getSpacingToken('200')}px 0 ${getSpacingToken('200')}px 0;
`;

export const AlertItemContent = styled(Stack)`
    padding: ${getSpacingToken('200')}px 0 ${getSpacingToken('200')}px 0;
    flex-grow: 1;
    overflow-wrap: anywhere;
`;
